import { MDText } from 'i18n-react';

import { getWordpress } from 'PublicAPI';

import { WordpressData } from '../../containers/app/contentPages/wordPressPages/@types/Wordpress';
import LocalTexts from '../../containers/app/contentPages/wordPressPages/components/GuideAuthorsContent/GuideAuthorsContent.text.json';

const LocalT = new MDText(LocalTexts);

type Author = {
  acf: {
    'featured_author': boolean;
    'profile_image'?: {
      sizes: {
        medium: string;
      };
    };
  };
  id: number;
  name: string;
  yoast_head_json: {
    schema: {
      '@graph': Array<{
        '@type': string;
        jobTitle?: string;
      }>;
    };
  };
}

type GetAuthorsResponse = Author[];

const formatAuthorsData = ({ data }: {data: GetAuthorsResponse}): WordpressData => {
  const featuredAuthors = data.filter((author: Author) => author.acf?.featured_author)
    .map((author) => {
      const jobTitle = author.yoast_head_json?.schema?.['@graph']?.find(
        (item) => item['@type'] === 'Person',
      )?.jobTitle || '';

      return {
        id: author.id,
        image: author.acf?.profile_image?.sizes?.medium || '',
        jobTitle,
        name: author.name,
      };
    });

  const wp = {
    archive: null,
    content: null,
    guideAuthors: featuredAuthors,
    meta: {
      desc: LocalT.translate('description') as string,
      title: LocalT.translate('title') as string,
    },
    posts: [],
    title: LocalT.translate('title') as string,
  };

  return wp;
};

export const getGuideAuthorsData = async () => {
  const body: GetAuthorsResponse = await getWordpress('/wp/v2/users?per_page=100', false, null);

  return formatAuthorsData({ data: body });
};
